import type { EventKind } from '@/types/database';

export type EventKindFilterMode = 'include' | 'exclude';
export type EventKindFilters = Partial<Record<EventKind, EventKindFilterMode>>;

export function cycleEventKindFilter(filters: EventKindFilters, kind: EventKind): EventKindFilters {
  const current = filters[kind];
  if (!current) return { ...filters, [kind]: 'include' };
  if (current === 'include') return { ...filters, [kind]: 'exclude' };
  const { [kind]: _removed, ...rest } = filters;
  return rest;
}

export function collectKinds(filters: EventKindFilters, mode: EventKindFilterMode): EventKind[] {
  return Object.entries(filters)
    .filter(([, value]) => value === mode)
    .map(([kind]) => kind as EventKind);
}
